"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { fill: colour, d: "M31.5 9a1.5 1.5 0 0 0-3 0v3.254A11.472 11.472 0 0 0 20 8.5C13.649 8.5 8.5 13.649 8.5 20S13.649 31.5 20 31.5c5.36 0 9.861-3.666 11.138-8.626a1.5 1.5 0 0 0-2.906-.748 8.5 8.5 0 1 1-1.751-7.626H23a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 1.5-1.5V9Z" }));
};
//# sourceMappingURL=Refresh.js.map